"use strict";

export function initInScope ($scope) {
   $(document).ready(function() {
        $scope.find('.js-animationStart').addClass('start-animation');
   });
}
